import { resourcePriceZodSchema } from "@@/shared/acquire/resource-price/resource-price";
import { requiredTranslatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";

//unit? description? resourceType?

const bookableTemplateQuantityZodObject = z.object({
    title: requiredTranslatableZodSchema,

    subtitle: requiredTranslatableZodSchema.optional(),

    quantity: z.number().min(1),

    unit: z
        .object({
            singular: requiredTranslatableZodSchema,
            plural: requiredTranslatableZodSchema,
        })
        .optional(),

    bookableVariants: z.array(
        z.object({
            title: requiredTranslatableZodSchema,
            price: resourcePriceZodSchema,
            minQuantity: z.number().min(0),
            maxQuantity: z.number().min(0),
            defaultQuantity: z.number().min(0),
        }),
    ),
});
type BookableTemplateQuantities = z.infer<
    typeof bookableTemplateQuantityZodObject
>;

export { bookableTemplateQuantityZodObject };
export type { BookableTemplateQuantities };
